import React from 'react';
import './Blogs.css';
import insta from '../image/insta.png';
import fb from '../image/fb.png';
import twitter from '../image/twitter.png';
import pic1 from '../image/pic1.jpeg';

const Blogs =() => {
    return (
        <div className="main1">
           
           <div className="Jumbotron1"> 
               
               <h1>Blogs</h1>
               <hr className="hr1"/>
               <p>Blogs will come soon..</p>
               
           </div>
           <div className="cr1">
      <div className="circle"></div>
        <div className="rect"></div>
        <img className="imgf" src={pic1} />
        <h4 className="nm">RishiQuote | رشی راج </h4>
        <p>&copy; 2020 - 2021 <a href="/">Privacy Policies</a></p>
        <div className="row2">
          <div className="column2">
            <p className="sh">SHARING</p>
          </div>
          <div className="column2">
            <p className="sh">NETWORKING</p>
          </div>
          <div className="column2">
            <p className="sh">LINKS</p>
          </div>
        </div>
        <div className="row1">
          <div className="column1">
            <a href="https://www.instagram.com/rishiquote">
              <img src={insta} />
            </a>
          </div>
          <div className="column1">
            <a href="https://www.facebook.com/rishiquote">
              <img src={fb} />
            </a>
          </div>
          <div className="column1">
            <img src={twitter} />
          </div>
        </div>
        <div className="ty">
          <p>Gazal</p>
          <p>Shayari</p>
          <p>Poetry</p>
        </div>
      </div>
        </div>
    );
    };
export default Blogs;